var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignLease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8101 14.2854H3.81006V13.1426H19.8101V14.2854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4287 19.428H3.42871V18.2852H11.4287V19.428Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1429 1.14286V9.71429H22.4762V16.9206L23.619 16.7302V9.14286L13.7143 0H1.14286C0.511674 0 0 0.511675 0 1.14286V30.8571C0 31.4883 0.511675 32 1.14286 32H22.4762C23.1074 32 23.619 31.4883 23.619 30.8571V26.2857L22.4762 28V30.8571L1.14286 30.8571L1.14286 1.14286H13.1429ZM14.2857 2.0828L21.3151 8.57143H14.2857V2.0828Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4287 23.4876L21.1253 21.8114L22.7811 23.4876L21.0845 25.1638L19.4287 23.4876Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8977 20.0171L24.5534 21.6933L32.0001 14.2434L30.3394 12.5723L22.8977 20.0171Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42871 26.1643H6.27472C6.48553 25.1485 6.52769 26.8609 7.53961 24.4229C8.55152 21.9848 8.8045 22.4311 8.8045 25.2936C8.8045 27.5334 9.76998 24.7472 11.1905 25.2936C13.4544 26.1643 14.2648 14.347 17.0119 16.1969C19.5615 17.9138 11.3725 24.9884 14.4246 25.2936C15.7516 25.4262 17.6587 25.2936 17.6587 25.2936",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignLease);
export default __webpack_public_path__ + "static/media/sign-lease.9a81f97f.svg";
export { ForwardRef as ReactComponent };